import heroImg from '@/assets/hero-lash.webp';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImg}
          alt="İpek kirpik uygulaması"
          width={1920}
          height={1080}
          fetchPriority="high"
          decoding="sync"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background/70 via-background/50 to-background" />
      </div>

      <div className="relative z-10 text-center px-5 max-w-3xl mx-auto pt-20">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-semibold leading-tight text-foreground mb-6 opacity-0 animate-fade-up">
          Her Bakışta Fark Yaratan Güzellik
        </h1>
        <p className="font-body text-base md:text-lg text-muted-foreground max-w-xl mx-auto mb-10 opacity-0 animate-fade-up" style={{ animationDelay: '0.2s' }}>
          Ankara Dikmen'in en özel ipek kirpik ve güzellik stüdyosu — Gamze Yücel ile profesyonel sonuçlar.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 opacity-0 animate-fade-up" style={{ animationDelay: '0.4s' }}>
          <a
            href="#randevu"
            className="px-8 py-3.5 rounded-full bg-blush text-foreground font-medium text-sm hover:opacity-90 transition-opacity"
          >
            Randevu Al
          </a>
          <a
            href="#hizmetler"
            className="px-8 py-3.5 rounded-full border border-foreground/20 text-foreground font-medium text-sm hover:bg-foreground/5 transition-colors"
          >
            Hizmetlerimizi Keşfet
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
